import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { SurveysFeelings } from '../types';
import { surveysQueryKeys } from '../config/queryKeys';
import { SelectedFilter } from '../../../components/Filters/types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

export const getFeelings = async (filters: SelectedFilter[]): Promise<SurveysFeelings> => {
  const response = await fetchApi.post('/surveys/feelings', filters) as SurveysFeelings;
  return response;
}

type QueryFnType = typeof getFeelings;

type UseFeelingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useFeelings = ({ config }: UseFeelingsOptions = {}) => {
  const filters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,  // No hacer refetch al montar si no est� obsoleto
    refetchOnWindowFocus: false,  // No hacer refetch al enfocar la ventana
    retry: false,                     // Disable automatic retries
    //retryOnMount: false,              // Prevent refetching on mount if it previously failed
    queryKey: [surveysQueryKeys.feelings.all, filters],
    queryFn: () => getFeelings(filters),
  });
}